/* promise/lib/index */ function _(require, module, exports) {
    module.exports = require(278) /* ./core.js */;
    require(279) /* ./done.js */;
    require(281) /* ./finally.js */;
    require(280) /* ./es6-extensions.js */;
    require(283) /* ./node-extensions.js */;
    require(284) /* ./synchronous.js */;
}
